import React from "react";
import { VideoComp } from "../../component/VideoComp";

export const Section4 = () => {
  return <div className="section4_container">
    <VideoComp src={"https://s3-figma-videos-production-sig.figma.com/video/1024950063253484681/USER/ba3a/ac1a/-d050-477e-8236-52b943dbf7a3?Expires=1717977600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=USOK4My0OhAyFe0DJEfZEvpwQj87U6AXId8UE9fo4g1XtZ9e5wDYcH3m7hbymd~tHwmokeDv90J3vlBzT~PoeFBXKrCVyRBEbkYXDff8t8UlOuKxuNB6HGzRWHUPn6g6Jdi98FARQAHiJ11-MbOQSzUUMjfCxnppmvB03u98J2wRGk16~v6j-ULBsqTEOn6eSzLPlhFUuVN2k8310CmDiISBXMcnPjGhy1P~5-Bc0o5CQLGkTGCRKjcpGEawP4pVd1IyGG7cnI2zlmRMM0goLxpxWhvh4pH3suDwkWKRy3ztezy-Pk5uGZQ-nWBZkh1PubmrdjGypwuSGitqM7aZLA__"}/>
  </div>;
};
